<div class="app-body">
  <main class="main d-flex align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-md-6 mx-auto">
          <div class="card-group">
            <div class="card p-4">
              <div class="card-body">
                <div class="d-flex justify-content-center">
                  <div class="logo-part">
                    <img src="assets/img/brand/logo.svg">
                  </div>
                </div>
                <form [formGroup]="loginForm" (ngSubmit)="submitLoginForm()" #formDir="ngForm" novalidate>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-user"></i></span>
                    </div>
                    <input type="text" class="form-control" placeholder="Email" formControlName="email">
                    <div class="error" *ngIf="(submitted && loginForm.controls.email.invalid) || loginForm.controls.email.touched">
                      <div *ngIf="loginForm.hasError('required','email')" class="err-msg">Please enter email address.
                      </div>
                      <div *ngIf="!loginForm.hasError('required','email') && loginForm.hasError('pattern','email')"
                        class="err-msg">Please enter valid email address.</div>
                    </div>
                  </div>
                  <div class="input-group mb-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-lock"></i></span>
                    </div>
                    <input type="password" class="form-control" placeholder="Password" formControlName="password" maxlength="16" onPaste="return false">
                    <div class="error" *ngIf="(submitted && loginForm.controls.password.invalid) || loginForm.controls.password.touched">
                      <div *ngIf="loginForm.hasError('required','password')" class="err-msg">Please enter password.</div>
                      <div *ngIf="!loginForm.hasError('required','password') && loginForm.hasError('minlength','password')" class="err-msg">Password must be between 6 to 16 characters.</div>
                      <!-- <div  *ngIf="!loginForm.hasError('required','password') && !loginForm.hasError('minlength','password') && loginForm.hasError('pattern','password')" class="err-msg">Please enter valid password.</div> -->
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <button type="submit" class="btn btn-dark px-4">Login</button>
                    </div>
                    <!-- <div class="col-6 text-right">
                      <button type="button" class="btn btn-link color-dark px-0" [routerLink]="['/forgot-password']">Forgot password?</button>
                    </div> -->
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
